import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/styles';
import { MerchantStatus } from '@nemuru-eng/js-api-client';
import { Fragment } from 'react';

import { statusDefinitions } from '@/components/shared/components/MerchantStateTag/config';
import { Text } from '@/components/shared/components/Text';
import { CustomPalette } from '@/config/types';
import { adjustColorToPalette } from '@/utils/getColorPalette';

export function MerchantStateTag({
  status,
  hideStatusName = false,
}: {
  status: MerchantStatus;
  hideStatusName?: boolean;
}) {
  const richStatus = statusDefinitions[status];
  const { palette }: { palette: CustomPalette } = useTheme();
  const color = adjustColorToPalette(richStatus.colorPaletteName, richStatus.colorType, palette);

  return (
    <Fragment>
      {richStatus ? (
        <Box display={'inline-flex'} alignItems={'center'}>
          <Box bgcolor={color} className={'circle mr-2'} style={{ marginBottom: '-1px' }} />
          {!hideStatusName && (
            <Box className={'line-clamp-3'}>
              <span style={{ color: palette.text.secondary, whiteSpace: 'break-spaces' }}>
                <Text tId={richStatus.SECTION_T_ID} />
              </span>
            </Box>
          )}
        </Box>
      ) : (
        status
      )}
    </Fragment>
  );
}
